// extracted by mini-css-extract-plugin
export default {"noticeview":"noticeview_bcaac7e5603ba94df9f1","icon":"icon_efc6aa2226372b2e0263","text":"text_bcc1edfe324dfeb65695"};